import reducers from './';
import { createLogger } from 'redux-logger';
import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';

const middleware = [
    thunkMiddleware
];

if (process.env.NODE_ENV !== 'production') {
    middleware.push(createLogger({
        collapsed: true
    }))
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(
    applyMiddleware(...middleware)
));

export default store;